/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCUpIcon20Solid = forwardRef('ArrowCUpIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2.778 13.597a1.375 1.375 0 0 1 0-1.944L7.79 6.64a3.125 3.125 0 0 1 4.42 0l5.012 5.013a1.375 1.375 0 0 1-1.944 1.944l-5.013-5.012a.375.375 0 0 0-.53 0l-5.013 5.012a1.375 1.375 0 0 1-1.944 0Z" })));
});
